import { render, staticRenderFns } from "./PublicPageSettings.vue?vue&type=template&id=827e998a&scoped=true"
import script from "./PublicPageSettings.vue?vue&type=script&lang=js"
export * from "./PublicPageSettings.vue?vue&type=script&lang=js"
import style0 from "./PublicPageSettings.vue?vue&type=style&index=0&id=827e998a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827e998a",
  null
  
)

export default component.exports